import * as React from 'react';
import { ExperimentsProvider, useExperiments, } from '@wix/wix-experiments-react';
import { TranslationProvider } from '../../hooks/use-translation';
import { ManageInstalledAppsPage } from '../manage-installed-apps-page';
import { ModalProvider } from '../../hooks/use-modal/use-modal';
export { Origin } from '../manage-installed-apps-page';
export function ManageInstalledApps(props) {
    const { experiments } = useExperiments();
    return (React.createElement(ExperimentsProvider, { options: { scope: 'app-market-editor' } },
        React.createElement(TranslationProvider, { locale: props.locale, baseUrl: props.manageAppsStaticsUrl, experiments: experiments },
            React.createElement(ModalProvider, null,
                React.createElement(ManageInstalledAppsPage, { ...props })))));
}
//# sourceMappingURL=index.js.map